import {apiRequest} from "./client";
import type {CampaignResponse, CmsPage, FaqResponse, ShopSiteStatus} from "./types";

export async function getCmsPage(slug: string): Promise<CmsPage> {
  return apiRequest<CmsPage>(`/cms/pages/${encodeURIComponent(slug)}`);
}

export async function getCampaignPage(): Promise<CampaignResponse> {
  return apiRequest<CampaignResponse>("/cms/campaign");
}

export async function getFaq(): Promise<FaqResponse> {
  return apiRequest<FaqResponse>("/cms/faq");
}

export async function getShopSiteStatus(): Promise<ShopSiteStatus> {
  return apiRequest<ShopSiteStatus>("/shop/status");
}
